import { useEffect } from 'react';

export default function UnknownUrl() {
  const myAccountSlug = window.myAccountPageSlug || 'my-account';

  useEffect(() => {
    window.location.replace(`/${myAccountSlug}`);
  }, [myAccountSlug]);

  return null;
}
